class ProfileCard extends HTMLElement {
    constructor() {
        super();
        this.btnOpen = this.querySelector('.profile__card-btn-open');
        this.btnOpen.addEventListener('click', this.toggleOpen.bind(this));
    }

    toggleOpen() {
        this.classList.toggle('open');
    }
}

customElements.define('profile-card', ProfileCard);
